// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonBorder{
  border: none !important;
}
svg.me-2 {
  margin-left: .5rem;
}
.input-group .btn {
  z-index: 0 !important;
}
/* Sidebar styles */
.sidebar-expanded {
    width: 270px;
    transition: width 0.3s ease-in-out;
  }
  .nav-item {
    width: 100%;
}
  .sidebar-collapsed {
    width: 70px !important;
    transition: width 0.3s ease-in-out;
  }
  
  .sidebar-expanded .nav-link
  {
    padding: 10px 15px;
    /* display: flex; */
    align-items: center;
  }
  .svgSzie svg{
    height: 17px !important;
    width: 17px !important;
  }
.svgSzie svg :nth-of-type(2) {
  height: 15px !important;
  width: 15px !important;
  border: 1px solid #ff0000;
}
/* .submenu-container .nav a svg {
    height: 6px ;
    width: 6px ;
    margin-left: 0px;
    margin-right: 5px !important;
}

.smallDot{
  height: 6px !important;
  width :6px !important
}
.submenu-container .nav a.pettyCash svg {
    height: 20px !important;
    width: 20px !important;
    margin-left: 10px !important;
} */

  .nav-link i {
    margin-right: 10px;
  }
  
  /* .sidebar-collapsed .nav-link span {
    display: none;
  } */
  
  .menu-label {
    transition: all 0.2s ease;
    white-space: nowrap;
    white-space: nowrap;
    font-weight: 600;
    font-size: 16px;
    padding: 4px 0 0;
    line-height: 1.4;
    display: inline-block;
  }
  

  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(1) a.nav-link {
   display: flex;
  }

  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(1) a.nav-link svg {
   position: absolute;
  }
  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(2) a.nav-link {
   display: flex;
  }

  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(2) a.nav-link svg {
   position: absolute;
  }  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(3) a.nav-link {
   display: flex;
  }

  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(3) a.nav-link svg {
   position: absolute;
  }
  .sidebar-collapsed  ul.nav.scroll li.nav-item .menu-label.collapsed {
    display: none;
    width: auto;
    background: #ed6c00;
    color: #fff;
    padding: 10px 5px 10px 5px;
    border-radius: 4px;
    position: absolute;
    left: 72px; 
    z-index: 999;
  }
  .menu-label.collapsed  + svg{
   display: none !important;
  }
  /* Show text on hover */
  .sidebar-collapsed ul.nav.scroll li.nav-item:hover .menu-label.collapsed {
    /* display: block;
    width: auto;
    background: #ed6c00;
    color: #fff;
    padding: 10px 5px 10px 5px;
    border-radius: 4px;
    position: absolute;
    left: 70px; 
    z-index: 999; */
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            background: #ED6C00;
            color: #fff;
            padding: 12px 0 10px 25px;
            left: 70px;
            position: absolute;
            text-align: left;
            width: 200px;
            z-index: 1;
            height: 55px;
            line-height: 1.4;
           border-radius: 0;
            


  }
  /* Sidebar Active Link */
  .nav-link.activeLink {
    background-color: transparent !important;
    border-left: none !important;
}

.sidebar li.nav-item a.nav-link:hover {
    background-color: #ed6c00 !important;
    border-left: 4px solid #fff !important;
    color: #fff !important;
}

.nav-tabs.nav-link:hover {
    background-color: #ed6c00 !important;
    border-left: 4px solid #fff !important;
    color: #fff !important;
}

.nav-link.active {
    background-color: #ED6C00;
    border-left: 4px solid #fff;
}

  
  .theme-color{
    color: rgb(54 58 61);
    background-color: rgb(30 68 105) !important;
  }
  #Profile {
    border-radius: 100%;
    width: 70%;
    /* height: 45px; */
}

.sidebar-collapsed .submenu-container {
   display: none;
   -webkit-box-align: center;
   -ms-flex-align: center;
    align-items: center;
  position: absolute;
  left: 70px; 
  background-color: #1f5186; 
  padding: 10px 0;
  border-radius: 0;
  z-index: 1000;
  padding: 12px 0 10px 25px;
   box-shadow: 0 0 10px rgba(0,0,0,0.2);
  min-width: 200px;
  max-height: 400px;
  overflow-y: auto; 


            /* display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            background-color: #1f5186; 
            color: #fff;
            padding: 12px 0 10px 25px;
            box-shadow: 0 0 10px rgba(0,0,0,0.2);
            left: 70px;
            position: absolute;
            text-align: left;
            width: 200px;
            z-index: 1;
            height: 55px;
            line-height: 1.4;
           border-radius: 0; */
}

.sidebar-collapsed .submenu-container a {
  display: block;
  color: white;
  padding: 8px 16px;
  text-decoration: none;
}

.sidebar-collapsed .submenu-container a:hover {
  background-color: #ed6c00 !important ;
}
.sidebar-collapsed .submenu-container .nav-link:hover {
  background-color: #ed6c00 !important;
}

.sidebar-collapsed .submenu-container a {
  color: white !important;
  padding: 8px 20px;
  white-space: nowrap;
}

.sidebar-collapsed .nav-item.has-submenu{
  display: flex;
}

.sidebar-expanded .nav-item.has-submenu{
  height: auto !important;
}
.submenu-container .nav-link {
  padding-left: 2rem !important;
  padding-right: 5px;
}

.submenu-container {
  background: inherit;
}

/* Show submenu on hover of nav-item that has aria-controls */
.sidebar-collapsed .nav-item.has-submenu:hover .submenu-container {
  display: block;
}

.submenu-label {
  transition: opacity 0.3s ease;
}

.sidebar-collapsed .nav-item.has-submenu:hover .submenu-container.nav a.nav-link + svg{
  display: none !important;
}
.hieght35{
  height:45px;
}






/* Sidebar base styles */
.sidebar {
  transition: all 0.3s ease-in-out;
  /* z-index: 1050; */
}

/* Mobile: Drawer from right */
.sidebar.mobile-hidden {
  transform: translateX(100%);
  position: fixed;
  top: 71px;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: #1E4469;
}

.sidebar.mobile-visible {
  transform: translateX(0%);
  position: fixed;
  top: 71px;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: #1E4469;
}
.pettyCash.active {
    background-color: transparent;
    border: none;
}
/* Desktop: Fixed on the left */
@media (min-width: 991px) {
  .sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    height: 100vh;
    /* width: 250px; */
    transform: none !important;
  }
}

.pr-0{
  padding-right: 0px !important;
}

.pl-0{
  padding-left: 0px !important;;
}

/* Mobile behavior */
.mobile-visible {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1050;
  width: 250px;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
}

.mobile-hidden {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1050;
  width: 250px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.user-profile.displayprofile{
  display: inline-block;
}
.user-profile.hideprofile{
  display: none;
}
.archive-menu .submenu-container .nav-link .me-2 {
    display: none;
}
.right {
  float: right;
  margin-top: 13px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA,mBAAmB;AACnB;IACI,YAAY;IACZ,kCAAkC;EACpC;EACA;IACE,WAAW;AACf;EACE;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;GAeG;;EAED;IACE,kBAAkB;EACpB;;EAEA;;KAEG;;EAEH;IACE,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;;EAGA;GACC,aAAa;EACd;;EAEA;GACC,kBAAkB;EACnB;EACA;GACC,aAAa;EACd;;EAEA;GACC,kBAAkB;EACnB,GAAG;GACF,aAAa;EACd;;EAEA;GACC,kBAAkB;EACnB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;EACA;GACC,wBAAwB;EACzB;EACA,uBAAuB;EACvB;IACE;;;;;;;;mBAQe;YACP,oBAAoB;YACpB,oBAAoB;YACpB,aAAa;YACb,yBAAyB;YACzB,sBAAsB;YACtB,mBAAmB;YACnB,mBAAmB;YACnB,WAAW;YACX,yBAAyB;YACzB,UAAU;YACV,kBAAkB;YAClB,gBAAgB;YAChB,YAAY;YACZ,UAAU;YACV,YAAY;YACZ,gBAAgB;WACjB,gBAAgB;;;;EAIzB;EACA,wBAAwB;EACxB;IACE,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;;EAGE;IACE,oBAAoB;IACpB,2CAA2C;EAC7C;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;GACG,aAAa;GACb,yBAAyB;GACzB,sBAAsB;IACrB,mBAAmB;EACrB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;GACxB,oCAAoC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;;;YAGN;;;;;;;;;;;;;;;;;8BAiBkB;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;;;;;;;AAOA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;IACI,6BAA6B;IAC7B,YAAY;AAChB;AACA,+BAA+B;AAC/B;EACE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,0BAA0B;EAC5B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;IACI,aAAa;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".buttonBorder{\r\n  border: none !important;\r\n}\r\nsvg.me-2 {\r\n  margin-left: .5rem;\r\n}\r\n.input-group .btn {\r\n  z-index: 0 !important;\r\n}\r\n/* Sidebar styles */\r\n.sidebar-expanded {\r\n    width: 270px;\r\n    transition: width 0.3s ease-in-out;\r\n  }\r\n  .nav-item {\r\n    width: 100%;\r\n}\r\n  .sidebar-collapsed {\r\n    width: 70px !important;\r\n    transition: width 0.3s ease-in-out;\r\n  }\r\n  \r\n  .sidebar-expanded .nav-link\r\n  {\r\n    padding: 10px 15px;\r\n    /* display: flex; */\r\n    align-items: center;\r\n  }\r\n  .svgSzie svg{\r\n    height: 17px !important;\r\n    width: 17px !important;\r\n  }\r\n.svgSzie svg :nth-of-type(2) {\r\n  height: 15px !important;\r\n  width: 15px !important;\r\n  border: 1px solid #ff0000;\r\n}\r\n/* .submenu-container .nav a svg {\r\n    height: 6px ;\r\n    width: 6px ;\r\n    margin-left: 0px;\r\n    margin-right: 5px !important;\r\n}\r\n\r\n.smallDot{\r\n  height: 6px !important;\r\n  width :6px !important\r\n}\r\n.submenu-container .nav a.pettyCash svg {\r\n    height: 20px !important;\r\n    width: 20px !important;\r\n    margin-left: 10px !important;\r\n} */\r\n\r\n  .nav-link i {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  /* .sidebar-collapsed .nav-link span {\r\n    display: none;\r\n  } */\r\n  \r\n  .menu-label {\r\n    transition: all 0.2s ease;\r\n    white-space: nowrap;\r\n    white-space: nowrap;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    padding: 4px 0 0;\r\n    line-height: 1.4;\r\n    display: inline-block;\r\n  }\r\n  \r\n\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(1) a.nav-link {\r\n   display: flex;\r\n  }\r\n\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(1) a.nav-link svg {\r\n   position: absolute;\r\n  }\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(2) a.nav-link {\r\n   display: flex;\r\n  }\r\n\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(2) a.nav-link svg {\r\n   position: absolute;\r\n  }  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(3) a.nav-link {\r\n   display: flex;\r\n  }\r\n\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item:nth-child(3) a.nav-link svg {\r\n   position: absolute;\r\n  }\r\n  .sidebar-collapsed  ul.nav.scroll li.nav-item .menu-label.collapsed {\r\n    display: none;\r\n    width: auto;\r\n    background: #ed6c00;\r\n    color: #fff;\r\n    padding: 10px 5px 10px 5px;\r\n    border-radius: 4px;\r\n    position: absolute;\r\n    left: 72px; \r\n    z-index: 999;\r\n  }\r\n  .menu-label.collapsed  + svg{\r\n   display: none !important;\r\n  }\r\n  /* Show text on hover */\r\n  .sidebar-collapsed ul.nav.scroll li.nav-item:hover .menu-label.collapsed {\r\n    /* display: block;\r\n    width: auto;\r\n    background: #ed6c00;\r\n    color: #fff;\r\n    padding: 10px 5px 10px 5px;\r\n    border-radius: 4px;\r\n    position: absolute;\r\n    left: 70px; \r\n    z-index: 999; */\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            background: #ED6C00;\r\n            color: #fff;\r\n            padding: 12px 0 10px 25px;\r\n            left: 70px;\r\n            position: absolute;\r\n            text-align: left;\r\n            width: 200px;\r\n            z-index: 1;\r\n            height: 55px;\r\n            line-height: 1.4;\r\n           border-radius: 0;\r\n            \r\n\r\n\r\n  }\r\n  /* Sidebar Active Link */\r\n  .nav-link.activeLink {\r\n    background-color: transparent !important;\r\n    border-left: none !important;\r\n}\r\n\r\n.sidebar li.nav-item a.nav-link:hover {\r\n    background-color: #ed6c00 !important;\r\n    border-left: 4px solid #fff !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.nav-tabs.nav-link:hover {\r\n    background-color: #ed6c00 !important;\r\n    border-left: 4px solid #fff !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.nav-link.active {\r\n    background-color: #ED6C00;\r\n    border-left: 4px solid #fff;\r\n}\r\n\r\n  \r\n  .theme-color{\r\n    color: rgb(54 58 61);\r\n    background-color: rgb(30 68 105) !important;\r\n  }\r\n  #Profile {\r\n    border-radius: 100%;\r\n    width: 70%;\r\n    /* height: 45px; */\r\n}\r\n\r\n.sidebar-collapsed .submenu-container {\r\n   display: none;\r\n   -webkit-box-align: center;\r\n   -ms-flex-align: center;\r\n    align-items: center;\r\n  position: absolute;\r\n  left: 70px; \r\n  background-color: #1f5186; \r\n  padding: 10px 0;\r\n  border-radius: 0;\r\n  z-index: 1000;\r\n  padding: 12px 0 10px 25px;\r\n   box-shadow: 0 0 10px rgba(0,0,0,0.2);\r\n  min-width: 200px;\r\n  max-height: 400px;\r\n  overflow-y: auto; \r\n\r\n\r\n            /* display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            background-color: #1f5186; \r\n            color: #fff;\r\n            padding: 12px 0 10px 25px;\r\n            box-shadow: 0 0 10px rgba(0,0,0,0.2);\r\n            left: 70px;\r\n            position: absolute;\r\n            text-align: left;\r\n            width: 200px;\r\n            z-index: 1;\r\n            height: 55px;\r\n            line-height: 1.4;\r\n           border-radius: 0; */\r\n}\r\n\r\n.sidebar-collapsed .submenu-container a {\r\n  display: block;\r\n  color: white;\r\n  padding: 8px 16px;\r\n  text-decoration: none;\r\n}\r\n\r\n.sidebar-collapsed .submenu-container a:hover {\r\n  background-color: #ed6c00 !important ;\r\n}\r\n.sidebar-collapsed .submenu-container .nav-link:hover {\r\n  background-color: #ed6c00 !important;\r\n}\r\n\r\n.sidebar-collapsed .submenu-container a {\r\n  color: white !important;\r\n  padding: 8px 20px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sidebar-collapsed .nav-item.has-submenu{\r\n  display: flex;\r\n}\r\n\r\n.sidebar-expanded .nav-item.has-submenu{\r\n  height: auto !important;\r\n}\r\n.submenu-container .nav-link {\r\n  padding-left: 2rem !important;\r\n  padding-right: 5px;\r\n}\r\n\r\n.submenu-container {\r\n  background: inherit;\r\n}\r\n\r\n/* Show submenu on hover of nav-item that has aria-controls */\r\n.sidebar-collapsed .nav-item.has-submenu:hover .submenu-container {\r\n  display: block;\r\n}\r\n\r\n.submenu-label {\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.sidebar-collapsed .nav-item.has-submenu:hover .submenu-container.nav a.nav-link + svg{\r\n  display: none !important;\r\n}\r\n.hieght35{\r\n  height:45px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Sidebar base styles */\r\n.sidebar {\r\n  transition: all 0.3s ease-in-out;\r\n  /* z-index: 1050; */\r\n}\r\n\r\n/* Mobile: Drawer from right */\r\n.sidebar.mobile-hidden {\r\n  transform: translateX(100%);\r\n  position: fixed;\r\n  top: 71px;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: #1E4469;\r\n}\r\n\r\n.sidebar.mobile-visible {\r\n  transform: translateX(0%);\r\n  position: fixed;\r\n  top: 71px;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: #1E4469;\r\n}\r\n.pettyCash.active {\r\n    background-color: transparent;\r\n    border: none;\r\n}\r\n/* Desktop: Fixed on the left */\r\n@media (min-width: 991px) {\r\n  .sidebar {\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    height: 100vh;\r\n    /* width: 250px; */\r\n    transform: none !important;\r\n  }\r\n}\r\n\r\n.pr-0{\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.pl-0{\r\n  padding-left: 0px !important;;\r\n}\r\n\r\n/* Mobile behavior */\r\n.mobile-visible {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 0;\r\n  z-index: 1050;\r\n  width: 250px;\r\n  transform: translateX(0);\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.mobile-hidden {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 0;\r\n  z-index: 1050;\r\n  width: 250px;\r\n  transform: translateX(100%);\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.user-profile.displayprofile{\r\n  display: inline-block;\r\n}\r\n.user-profile.hideprofile{\r\n  display: none;\r\n}\r\n.archive-menu .submenu-container .nav-link .me-2 {\r\n    display: none;\r\n}\r\n.right {\r\n  float: right;\r\n  margin-top: 13px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
